import logo from './logo.svg';
import './App.css';
import Home from './Components/Pages/Home.js'

function App() {
  return (
    <Home></Home>
  );
}

export default App;
